module.exports = __webpack_public_path__ + "static/media/react-icon.96b80a72.svg";